import axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'

import { USE_MOCK } from './config'
import { getToken, removeToken } from './auth'

const baseURL = '/api'

const apiClient: AxiosInstance = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  withCredentials: false,
})

// Request interceptor - add JWT token if available
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor - handle auth errors
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 302) {
      removeToken()
      sessionStorage.removeItem('isLoggedIn')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('userRole')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default apiClient

// Generic request helper
export async function request<T = any>(
  url: string,
  config?: AxiosRequestConfig
): Promise<T> {
  const response = await apiClient.request<any, T>({ url, ...config })
  return response
}

// POST with form data
export async function postForm<T = any>(
  url: string,
  data: Record<string, any>
): Promise<T> {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined && value !== null) {
      params.append(key, String(value))
    }
  }
  return request<T>(url, {
    method: 'POST',
    data: params,
  })
}
